import React from "react";

function AccessDenied() {
  return (
    <div style={{ textAlign: "center" }}>
      <h3>403 Access Denied.</h3>
    </div>
  );
}

export default AccessDenied;
